import { render, staticRenderFns } from "./TransferPositionID.vue?vue&type=template&id=908e935c&scoped=true&"
import script from "./TransferPositionID.vue?vue&type=script&lang=js&"
export * from "./TransferPositionID.vue?vue&type=script&lang=js&"
import style0 from "./TransferPositionID.vue?vue&type=style&index=0&id=908e935c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908e935c",
  null
  
)

export default component.exports